import React from 'react';
import { Svg, ISvg } from '../../Svg';

export const VideoContentApp: React.FC<ISvg> = (props) => (
  <Svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M20.6275 9.2775L7.75 1.8375C7.3819 1.61972 6.96269 1.50327 6.535 1.5C5.86268 1.5 5.21789 1.76708 4.74248 2.24248C4.26708 2.71789 4 3.36268 4 4.035V20.0025C4.00009 20.4487 4.11969 20.8867 4.34637 21.2709C4.57305 21.6552 4.89853 21.9718 5.28898 22.1877C5.67942 22.4035 6.12057 22.5109 6.56656 22.4986C7.01255 22.4862 7.44709 22.3546 7.825 22.1175L20.7175 13.9725C21.1184 13.7216 21.4474 13.3712 21.6726 12.9553C21.8977 12.5394 22.0113 12.0723 22.0022 11.5995C21.9932 11.1267 21.8618 10.6643 21.6208 10.2573C21.3799 9.85042 21.0377 9.51283 20.6275 9.2775Z"
      fill="white"
    />
  </Svg>
);
